import { IconEditOrders } from '../../../../../../../assets/DesignSystem/SVGComponents';
import { IShipmentData, SHIPMENT_STATUS } from '../../../../../../../types/orders';
import { formatShortDate } from '../../../../../../../utils/formatDatesAndHours';
import './ShipmentTrackingData.scss';

const ShipmentTrackingData = ({
  shipmentData,
  countryTimeZone,
  setShowProcessModal,
  setIsEditedProcessModal
}: {
  shipmentData: IShipmentData;
  countryTimeZone?: number;
  setShowProcessModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEditedProcessModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { trackingInfo, status } = shipmentData || {};
  const { trackingLink, trackerNumber, currentEstimatedDeliverDate } = trackingInfo || {};

  const shipmentWasDelivered = status === SHIPMENT_STATUS.DELIVERED;
  const shipmentWasCancelled = status === SHIPMENT_STATUS.CANCELLED;
  const shipmentIsOnCourse = !shipmentWasDelivered && !shipmentWasCancelled;
  const noDataText = 'Sin datos';
  const activeStyles = status === SHIPMENT_STATUS.DELIVERY_PROCESS ? 'active' : '';
  const trackingLinkIsValid = trackingLink && (trackingLink.includes('http://') || trackingLink.includes('https://'));
  const linkStyles = trackingLinkIsValid ? 'link' : '';

  const openUrl = () => {
    if (trackingLinkIsValid) {
      window.open(trackingLink, '_blank');
    }
  };

  const handleEditEstimatedDates = () => {
    if (!shipmentIsOnCourse) return;
    setShowProcessModal(true);
    setIsEditedProcessModal(true);
  };

  return (
    <div className={`shipmentTrackingData ${activeStyles}`}>
      {currentEstimatedDeliverDate && (
        <div className="estimatedDatesSection">
          <div className="trackingDataField estimatedDate">
            Fecha limite estimada: {formatShortDate(currentEstimatedDeliverDate, countryTimeZone)?.textWithTimezone}
            {shipmentIsOnCourse && <IconEditOrders onClick={handleEditEstimatedDates} className="marginIcon" />}
          </div>
          <div className="oldDatesBlock">
            {shipmentData?.trackingInfo?.oldEstimatedDeliveryDates &&
              shipmentData?.trackingInfo?.oldEstimatedDeliveryDates?.length > 0 &&
              shipmentData?.trackingInfo?.oldEstimatedDeliveryDates.map((item, index) => {
                return (
                  <div className="oldDate" key={`old-date-${item}-index=${index}`}>
                    {formatShortDate(item)?.textWithTimezone}
                  </div>
                );
              })}
          </div>
        </div>
      )}
      {trackingLink && (
        <div className="trackingDataField trackingLinkField">
          Link de rastreo:{' '}
          <div className={linkStyles} onClick={openUrl}>
            {trackingLink || noDataText}
          </div>
        </div>
      )}
      {trackerNumber && <div className="trackingDataField">Código: {trackerNumber || noDataText}</div>}
    </div>
  );
};

export default ShipmentTrackingData;
